const send_echo_signal = (signal) => {
  if (window && window.postMessage) {
    window.postMessage({ text: signal, source: "cog-test" }, "*");
  }
};

export default send_echo_signal;
